export default __webpack_public_path__ + "static/media/eu-flag.9493b3c4.jpg";